import Exception from './Exception';
/**
 * Custom Error class of type Exception.
 */
class ArgumentException extends Exception {
}
ArgumentException.kind = 'ArgumentException';
export default ArgumentException;
